import { EnterpriseContactThanksPageTemplate } from "@/templates/enterprise/contact-thanks/enterprise-contact-thanks-page/src";

export const EnterpriseContactThanksPage = () => (
    <EnterpriseContactThanksPageTemplate />
);
